import React from 'react';
import { Descriptions, List, Tag } from 'antd';
import { toPrice } from 'Utils/utils';
import { toDateString } from 'Utils/utils';
import styles from './productVariantDisplay.module.less';

class ProductVariantDisplay extends React.Component {
  getPhone = () => {
    const pv = this.props.productVariant;
    if (!pv || !pv.attributes || !pv.attributes['phone'] || pv.attributes['phone'].length === 0) {
      return {};
    }
    return this.props.allPhones.find(p => p.id === pv.attributes['phone'][0]) || {};
  };

  renderPhone = (pv, item) => {
    if (!pv.attributes[item.code] || pv.attributes[item.code].length === 0) {
      return this.renderListItem(item, '');
    }
    const phone = this.props.allPhones.find(p => p.id === pv.attributes[item.code][0]);
    if (!phone) {
      return this.renderListItem(item, '');
    }
    return this.renderListItem(item, phone.name);
  };

  renderAttr = (pv, item) => {
    return item.code === 'phone'
      ? this.renderPhone(pv, item)
      : this.renderListItem(item, (pv.attributes[item.code] || []).join(', '));
  };

  renderListItem = (item, value) => {
    return (
      <List.Item key={item.code}>
        {item.label} ({item.code}) =&gt; {value}
      </List.Item>
    );
  };

  render() {
    const { productVariant: pv, product, compact } = this.props;

    if (!pv) {
      return null;
    }

    const custGrp = (this.props.allCustGrp || []).reduce((map, obj) => {
      map[obj.id] = obj.name;
      return map;
    }, {});

    if (compact) {
      return (
        <Descriptions bordered column={1} size="small">
          <Descriptions.Item label="Variant Name">{pv.name}</Descriptions.Item>
          <Descriptions.Item label="Product Name">{product?.name || '-'}</Descriptions.Item>
          <Descriptions.Item label="Variant Number">{pv.variantNumber}</Descriptions.Item>
          <Descriptions.Item label="SKU">{pv.sku}</Descriptions.Item>
          <Descriptions.Item label="UPC">{pv.attributes?.['upc']?.join(', ') || '-'}</Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={pv.stockStatus === 'IN_STOCK' ? 'green' : 'orange'}>{pv.stockStatus}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Enabled">
            <Tag color={pv.enabled ? 'green' : 'red'}>{pv.enabled ? 'Yes' : 'No'}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Price">${pv.price}</Descriptions.Item>
          {pv.specialPrice && <Descriptions.Item label="Special Price">${pv.specialPrice}</Descriptions.Item>}
        </Descriptions>
      );
    }

    return (
      <div className={styles.productVariantDisplay}>
        <Descriptions bordered column={2} size="small" title="Details">
          <Descriptions.Item label="Variant Name">{pv.name}</Descriptions.Item>
          <Descriptions.Item label="Product Name">{product?.name || '-'}</Descriptions.Item>
          <Descriptions.Item label="Variant Number">{pv.variantNumber}</Descriptions.Item>
          <Descriptions.Item label="Product Url">{product?.url || '-'}</Descriptions.Item>
          <Descriptions.Item label="Variant Sku">{pv.sku}</Descriptions.Item>
          <Descriptions.Item label="Product Sku">{product?.sku || '-'}</Descriptions.Item>
          <Descriptions.Item label="Status">{pv.stockStatus}</Descriptions.Item>
          <Descriptions.Item label="Enabled">{pv.enabled ? 'Yes' : 'No'}</Descriptions.Item>
          <Descriptions.Item label="Price">${pv.price}</Descriptions.Item>
          <Descriptions.Item label="Special Price">{pv.specialPrice ? '$' + pv.specialPrice : '-'}</Descriptions.Item>
          <Descriptions.Item label="Special Price From">{toDateString(pv.specialPriceFrom)}</Descriptions.Item>
          <Descriptions.Item label="Special Price To">{toDateString(pv.specialPriceTo)}</Descriptions.Item>
          <Descriptions.Item label="Weight">{pv.weight}</Descriptions.Item>
          <Descriptions.Item label="New To">{pv.newTo}</Descriptions.Item>
          <Descriptions.Item label="Tag Option">{pv.tag && pv.tag.name}</Descriptions.Item>
          <Descriptions.Item label="Tag Start Date">{toDateString(pv.tagStartDate)}</Descriptions.Item>
          <Descriptions.Item label="Tag End Date">{toDateString(pv.tagEndDate)}</Descriptions.Item>
          <Descriptions.Item span={2} label="Description">{pv.description}</Descriptions.Item>
          <Descriptions.Item span={2} label="Short Description">{pv.shortDescription}</Descriptions.Item>
        </Descriptions>

        {pv.tierPrices && Object.keys(pv.tierPrices).length > 0 && (
          <Descriptions bordered column={1} size="small" title="Tier Prices">
            {Object.keys(pv.tierPrices).map(tp => (
              <Descriptions.Item key={tp} label={custGrp[tp]}>
                <div className={styles.bulkPricing}>
                  {pv.tierPrices[tp].map((p, idx) => (
                    <div key={idx} className={styles.bulkPricingUnit}>
                      <div className={styles.qty}>{p.qty}</div>
                      <div>{toPrice(p.price)}</div>
                    </div>
                  ))}
                </div>
              </Descriptions.Item>
            ))}
          </Descriptions>
        )}

        {this.props.categories && this.props.categories.length > 0 && (
          <List
            className="view-data-list"
            header="Categories"
            bordered
            dataSource={this.props.categories}
            renderItem={item => <List.Item>{item.name}</List.Item>}
          />
        )}

        {this.props.attrs && this.props.attrs.length > 0 && (
          <List
            className="view-data-list"
            header="Attributes"
            bordered
            dataSource={this.props.attrs.filter(a => pv.attributes && pv.attributes[a.code] !== undefined)}
            renderItem={item => this.renderAttr(pv, item)}
          />
        )}

        <Descriptions bordered column={1} size="small" title="Meta Information">
          <Descriptions.Item label="Meta Title">{pv.metaTitle}</Descriptions.Item>
          <Descriptions.Item label="Meta Keywords">{pv.metaKeywords}</Descriptions.Item>
          <Descriptions.Item label="Meta Description">{pv.metaDescription}</Descriptions.Item>
        </Descriptions>

        <Descriptions bordered column={2} size="small" title="Audit Information">
          <Descriptions.Item label="Created By">
            {pv.createdBy && pv.createdBy.name ? pv.createdBy.name : ''}
          </Descriptions.Item>
          <Descriptions.Item label="Created On">{toDateString(pv.createdOn)}</Descriptions.Item>
          <Descriptions.Item label="Updated By">
            {pv.updatedBy && pv.updatedBy.name ? pv.updatedBy.name : ''}
          </Descriptions.Item>
          <Descriptions.Item label="Updated On">{toDateString(pv.updatedOn)}</Descriptions.Item>
        </Descriptions>

        {pv.assets && pv.assets.length > 0 && (
          <List
            className="view-data-list"
            header="Images"
            bordered
            dataSource={pv.assets}
            renderItem={item => (
              <List.Item>
                <img src={item.path} alt={item.title} className={styles.productImg} />
              </List.Item>
            )}
          />
        )}
      </div>
    );
  }
}

export default ProductVariantDisplay;
